module.exports = {"status_open":"Offen","status_closed":"Abgeschlossen","status_pending":"In Arbeit"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/project/de.json
// module id = 1402
// module chunks = 1